import { render, staticRenderFns } from "./pesoParaLaEdadNinos5a10A.vue?vue&type=template&id=0e884d06&scoped=true&"
import script from "./pesoParaLaEdadNinos5a10A.vue?vue&type=script&lang=js&"
export * from "./pesoParaLaEdadNinos5a10A.vue?vue&type=script&lang=js&"
import style0 from "./pesoParaLaEdadNinos5a10A.vue?vue&type=style&index=0&id=0e884d06&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e884d06",
  null
  
)

export default component.exports